import { isReactNative } from 'yofobasement/utils/runtime';

export default {
  addEventListener: (key, callback) => {
    if (isReactNative()) {
      return require('react-native').BackHandler.addEventListener(key, callback);
    }
  }
};



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/BackHandler.js